export const GET_REPORTS_REQUEST = "GET_REPORTS_REQUEST";
export const GET_REPORTS_RESPONSE = "GET_REPORTS_RESPONSE";

export const GET_REPORT_DETAIL_REQUEST = "GET_REPORT_DETAIL_REQUEST";
export const GET_REPORT_DETAIL_RESPONSE = "GET_REPORT_DETAIL_RESPONSE";

export const CREATE_REPORT_REQUEST = "CREATE_REPORT_REQUEST";
export const CREATE_REPORT_RESPONSE = "CREATE_REPORT_RESPONSE";

export const EXPORT_REPORT_SHEET_REQUEST = "EXPORT_REPORT_SHEET_REQUEST";

export const UPDATE_REPORT_REQUEST = "UPDATE_REPORT_REQUEST";
export const UPDATE_REPORT_RESPONSE = "UPDATE_REPORT_RESPONSE";

export const GET_REPORT_COMMENTS_REQUEST = "GET_REPORT_COMMENTS_REQUEST";
export const GET_REPORT_COMMENTS_RESPONSE = "GET_REPORT_COMMENTS_RESPONSE";

export const CREATE_REPORT_COMMENT_REQUEST = "CREATE_REPORT_COMMENT_REQUEST";
export const CREATE_REPORT_COMMENT_RESPONSE = "CREATE_REPORT_COMMENT_RESPONSE";
